/* Jewelry Depot — Sticky Add-to-Bag Bar (Impulse v8.2.1)
   States: hidden | active | sold-out | added                       2026-05-23 */
(() => {
  const bar = document.getElementById('jd-sticky-atc');
  if (!bar) return;

  // Escape any transformed ancestor that would capture position:fixed.
  if (bar.parentElement !== document.body) document.body.appendChild(bar);

  // NOTE: do NOT filter `:not([disabled])` — Impulse renders the ATC disabled
  // until its product-form JS hydrates. The IntersectionObserver only needs
  // the position of whichever anchor we settle on.
  const ATC_SEL   = 'product-form button[type="submit"], .product-form__submit, button[name="add"], form[action*="/cart/add"] button[type="submit"]';
  const MODAL_CLS = ['js-drawer-open', 'cart-open', 'modal-open', 'video-modal-open'];
  const OPEN_EVTS = ['drawerOpen', 'modalOpen', 'cart:open'];

  // Always anchor to the native ATC button. The bar reveals ONLY after the
  // button has scrolled above the top of the viewport; while it's visible — or
  // still below the fold on initial load — the bar stays hidden.
  const nativeAtc = document.querySelector(ATC_SEL);
  const anchorEl  = nativeAtc;
  if (!anchorEl) return;

  const s = {
    revealed: false, modalOpen: false, ready: false, busy: false,
    added: false, justAdded: false,
    inStock: bar.dataset.inStock === 'true',
  };

  // Mirror in-cart state onto the native ATC button (class + disabled + text).
  let origAtcHtml = null;
  const syncNativeAtc = (inCart) => {
    if (!nativeAtc) return;
    if (inCart) {
      if (origAtcHtml === null) origAtcHtml = nativeAtc.innerHTML;
      nativeAtc.classList.add('btn--in-cart');
      nativeAtc.disabled = true;
      nativeAtc.innerHTML = '&#10003; Added to Shopping Bag';
    } else {
      nativeAtc.classList.remove('btn--in-cart');
      nativeAtc.disabled = false;
      if (origAtcHtml !== null) { nativeAtc.innerHTML = origAtcHtml; origAtcHtml = null; }
    }
  };

  const render = () => {
    const n = s.modalOpen                                    ? 'hidden'
            : s.added                                        ? 'added'
            : (!s.ready || !s.revealed)                      ? 'hidden'
            : !s.inStock                                     ? 'sold-out'
            :                                                  'active';
    bar.dataset.cartSource = s.justAdded ? 'fresh' : 'existing';
    if (bar.dataset.state === n) return;
    bar.dataset.state = n;
    bar.setAttribute('aria-hidden', n === 'hidden');
    bar.hidden = n === 'hidden';
    syncNativeAtc(n === 'added');
  };
  const set = (k, v) => { if (s[k] !== v) { s[k] = v; render(); } };

  // sessionStorage cache: persists across soft reloads, cleared on tab close / hard refresh.
  const CART_CACHE_KEY = 'jd_cart_v';
  const readCartCache  = () => { try { return JSON.parse(sessionStorage.getItem(CART_CACHE_KEY) || '[]'); } catch (_) { return []; } };
  const writeCartCache = ids => { try { sessionStorage.setItem(CART_CACHE_KEY, JSON.stringify(ids)); } catch (_) {} };

  // Check /cart.js and sync s.added to whether the current variant is in the cart.
  const checkCartForVariant = async () => {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const items = cart.items || [];
      writeCartCache(items.map(it => String(it.variant_id)));
      const inCart = items.some(it => String(it.variant_id) === String(bar.dataset.variantId));
      s.added = inCart;
      render();
    } catch (_) {}
  };

  // Pre-seed from cache so the bar shows in the correct state before the network resolves.
  if (readCartCache().includes(String(bar.dataset.variantId))) s.added = true;

  // Page-ready gate (400ms grace after DOMContentLoaded).
  // Only fetch /cart.js on the very first session visit — after that the cache is
  // maintained entirely by sticky-bar adds and the ajaxProduct:added listener.
  const ready = () => setTimeout(() => {
    set('ready', true);
    if (sessionStorage.getItem(CART_CACHE_KEY) === null) checkCartForVariant();
  }, 400);
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', ready)
    : ready();

  // Reveal gate — show the bar ONLY once the ADD TO BAG button has scrolled
  // above the top of the viewport (boundingClientRect.bottom <= 0). While the
  // button is visible, or still below the fold on initial load, keep it hidden.
  // threshold:0 fires the callback at each viewport-edge crossing, which is
  // exactly when the reveal state can flip.
  new IntersectionObserver(([e]) => set('revealed', e.boundingClientRect.bottom <= 0), { threshold: 0 }).observe(anchorEl);

  // Track variant changes for in-stock / variant id / thumbnail.
  // Guard: ignore the initial echo that Impulse dispatches on product-form
  // hydration with the *current* variant — otherwise it can override the
  // server-rendered in_stock=false with a stale "true" and flip the bar from
  // sold-out to active. Only react to genuine variant changes.
  document.addEventListener('variant:change', ({ detail }) => {
    const v = detail?.variant;
    if (!v) return;
    if (String(v.id) === String(bar.dataset.variantId)) return;
    s.inStock = !!v.available;
    s.justAdded = false;
    s.added = readCartCache().includes(String(v.id));
    bar.dataset.variantId = v.id;
    const priceEl = bar.querySelector('[data-jd-price]');
    if (priceEl && v.price != null) {
      priceEl.textContent = window.Shopify?.formatMoney?.(v.price) ?? `$${(v.price / 100).toFixed(2)}`;
    }
    // Variant-specific image: swap when present, leave alone otherwise so we
    // don't blank out the product fallback that was rendered server-side.
    const thumb = bar.querySelector('.jd-bar-thumb');
    const variantImg = v.featured_image?.src || v.featured_media?.preview_image?.src;
    if (thumb && variantImg) {
      const url = new URL(variantImg, location.href);
      url.searchParams.set('width', '300');
      thumb.src = url.toString();
    }
    render();
  });

  // Ring-size carry-over — mirrors snippets/jd-ring-size-selector.liquid so the
  // sticky bar uses the same source of truth as the main PDP ATC form. Only
  // applied when the product is a Ring; otherwise we'd risk tagging non-ring
  // items with a stale size from a prior session.
  const RING_STORAGE_KEY    = 'jd_last_ring_size';
  const RING_STORAGE_TTL_MS = 1000 * 60 * 60 * 24 * 90; // 90 days
  const isRing = (bar.dataset.productType || '').toLowerCase() === 'rings';

  const readSavedRingSize = () => {
    try {
      const raw = window.localStorage.getItem(RING_STORAGE_KEY);
      if (!raw) return '';
      if (raw.charAt(0) !== '{') return raw; // back-compat: legacy plain string
      const obj = JSON.parse(raw);
      if (!obj || !obj.v) return '';
      if (obj.t && (Date.now() - obj.t) > RING_STORAGE_TTL_MS) return '';
      return obj.v;
    } catch (e) { return ''; }
  };

  // On-page hidden input wins (it reflects this session's selection); fall
  // back to localStorage so a previously-chosen size still carries over even
  // when the shopper hasn't touched the selector on the current PDP.
  const getRingSizeForCart = () => {
    if (!isRing) return '';
    const hidden = document.querySelector('input[name="properties[customer_ring_size]"]');
    const fromForm = hidden && hidden.value ? String(hidden.value).trim() : '';
    if (fromForm) return fromForm;
    return readSavedRingSize();
  };

  // Add to Bag — direct AJAX, bypasses Impulse's ring-size form validator.
  // Inventory of nearly every item is 1 (one-of-a-kind pieces), so the same
  // variant must never appear on two separate lines. If the variant is
  // already in the cart, update that line's properties in place (e.g. swap
  // ring size) rather than creating a duplicate.
  // Swallow click bubbling from the bar itself so no document-level outside-click
  // handler can interpret bar clicks (e.g. close a drawer). Buttons inside the bar
  // still receive their own clicks first — this only guards the bubble phase.
  bar.addEventListener('click', e => e.stopPropagation());

  bar.querySelector('[data-jd-primary-action]')?.addEventListener('click', async e => {
    e.preventDefault();
    if (bar.dataset.state === 'added') {
      window.location.href = '/cart';
      return;
    }
    if (s.busy || bar.dataset.state !== 'active') return;
    s.busy = true;
    const btn = e.currentTarget;
    btn.disabled = true;

    try {
      const variantId = String(bar.dataset.variantId);
      const ringSize = getRingSizeForCart();

      const cartRes = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
      });
      const cart = cartRes.ok ? await cartRes.json() : { items: [] };
      const items = (cart && cart.items) || [];
      const existingIndex = items.findIndex(it => String(it.variant_id) === variantId);

      if (existingIndex !== -1) {
        // Merge: preserve any existing line-item properties (engraving,
        // resizing_fee, etc.) and only overwrite customer_ring_size if we
        // have a fresh value to apply.
        const existing = items[existingIndex];
        const mergedProps = Object.assign({}, existing.properties || {});
        if (ringSize) mergedProps.customer_ring_size = ringSize;

        const changeRes = await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            line: existingIndex + 1, // Shopify uses 1-based line indexes
            quantity: existing.quantity || 1,
            properties: mergedProps,
          }),
        });
        if (!changeRes.ok) throw new Error(`HTTP ${changeRes.status}`);
      } else {
        const payload = { id: variantId, quantity: 1 };
        if (ringSize) payload.properties = { customer_ring_size: ringSize };

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
      }

      // Update cache and state before dispatching ajaxProduct:added — the event
      // fires synchronously so s.justAdded must be true before the listener runs.
      const cached = readCartCache();
      if (!cached.includes(variantId)) writeCartCache([...cached, variantId]);
      s.justAdded = true;
      s.added = true;
      render();
      setTimeout(() => { s.justAdded = false; render(); }, 1800);

      // Notify Impulse so the cart count/drawer state updates. ajaxProduct:added
      // alone drives the CartDrawer rebuild + open (assets/theme.js). We
      // intentionally no longer also dispatch cart:build: it triggered a second,
      // redundant /cart?view=ajax rebuild of the already-open drawer — a race
      // vector for the checkout/review tap. One rebuild, one open.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    } catch (err) {
      console.error('[jd-sticky-atc] add failed', err);
      btn.disabled = false;
    } finally {
      s.busy = false;
      setTimeout(() => { btn.disabled = false; }, 1800);
    }
  });

  // Inquire button — open the Shopify Inbox chat widget. Inbox renders as
  // <inbox-online-store-chat id="ShopifyChat"> with a declarative shadow root
  // containing button[data-spec="toggle-button"]. Falls back to inquire URL.
  bar.querySelector('[data-jd-inquire-action]')?.addEventListener('click', e => {
    e.preventDefault();
    const log = (msg, extra) => console.info('[jd-sticky-atc/chat]', msg, extra ?? '');

    // Selectors that actually exist on Shopify Inbox today (verified 2026-05-25).
    // Listed broadest-first so future tweaks to data-spec/class don't break us.
    const BTN_SELECTORS = [
      'button[data-spec="toggle-button"]',
      'button.chat-toggle',
      'button[part="chat-button"]',
      'button#chat-button',
      'button[aria-label*="chat" i]',
      'button[aria-label*="message" i]',
    ];

    // 1) Direct lookup by the known Shopify Inbox host id.
    const inboxHost = document.getElementById('ShopifyChat')
      || document.querySelector('inbox-online-store-chat, shop-chat, shopify-chat, shopify-chat-widget, shopify-inbox-chat');

    if (inboxHost?.shadowRoot) {
      for (const sel of BTN_SELECTORS) {
        const btn = inboxHost.shadowRoot.querySelector(sel);
        if (btn) { log('clicked', `#${inboxHost.id || inboxHost.tagName.toLowerCase()} >> ${sel}`); btn.click(); return; }
      }
      log('host found but no matching button inside shadow root', inboxHost);
    } else if (inboxHost) {
      log('host found but shadowRoot is null (declarative shadow DOM may not have attached)', inboxHost);
    }

    // 2) Generic shadow-DOM sweep — last resort for forks/renames.
    for (const el of document.querySelectorAll('*')) {
      if (!el.shadowRoot) continue;
      for (const sel of BTN_SELECTORS) {
        const btn = el.shadowRoot.querySelector(sel);
        if (btn) { log('clicked (sweep)', `${el.tagName.toLowerCase()} >> ${sel}`); btn.click(); return; }
      }
    }

    // 3) Nothing found — fall back to configured URL.
    log('no chat widget detected; falling back to', bar.dataset.inquireFallback);
    if (bar.dataset.inquireFallback) location.href = bar.dataset.inquireFallback;
  });

  // Sync cache + state when a native PDP form adds to cart. Fires only on actual add
  // actions (not on cart-drawer opens/refreshes), and carries the variant_id in the
  // event detail so we can update state without a /cart.js round-trip. Sticky-bar adds
  // dispatch this event with no detail — those are already handled inline above.
  document.addEventListener('ajaxProduct:added', e => {
    const addedId = e.detail?.product?.variant_id;
    if (!addedId) return;
    const id = String(addedId);
    const cached = readCartCache();
    if (!cached.includes(id)) writeCartCache([...cached, id]);
    if (id === String(bar.dataset.variantId) && !s.added) { s.added = true; render(); }
  });

  // Sync cache + state when items are removed or quantity-changed via the cart drawer.
  // Impulse dispatches `cart:updated` only on actual cart changes (never on drawer opens),
  // and the parsed cart rides in event.detail.cart — so removes propagate with no /cart.js
  // round-trip. This is the only place that detects removes.
  document.addEventListener('cart:updated', e => {
    const cart = e.detail?.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    const ids = cart.items.map(it => String(it.variant_id));
    writeCartCache(ids);
    const inCart = ids.includes(String(bar.dataset.variantId));
    if (s.added !== inCart) { s.added = inCart; render(); }
  });

  // Modal/drawer suppression — events + <html> class observer
  OPEN_EVTS.forEach(ev => document.addEventListener(ev, () => set('modalOpen', true)));
  new MutationObserver(() => set('modalOpen', MODAL_CLS.some(c => document.documentElement.classList.contains(c))))
    .observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();
